<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    class="agpr-videoInput agpr-contextMenu-parent"
    [ngClass]="{
        'agpr-videoInput--disabled': isDisabled,
        'agpr-videoInput--showingPreview': !editable && content && isValidURL()
    }"
>
    <div *ngIf="!isDisabled" class="agpr-videoInput-iconBlock" [ngClass]="{'agpr-videoInput-iconBlock--mod':editable}">
        <button pButton type="button" class="agpr-videoInput-delete" icon="fa-regular fa-duotone fa-trash-can" *ngIf="showDelete" (click)="onDelete($event)"></button>
        <button pButton type="button" class="agpr-videoInput-edit" icon="fa-regular fa-duotone fa-pen" (click)="onEdit($event)"></button>
    </div>
    <div
        class="agpr-contextMenu top left"
        *ngIf="showMoveButtons && !isDisabled"
    >
        <button
            pButton
            [disabled]="moveUpDisabled"
            type="button"
            icon="fa-regular fa-arrow-up"
            class="agpr-videoInput-moveUp"
            (click)="onMoveUp()"
        >
        </button>
        <button
            pButton
            [disabled]="moveDownDisabled"
            type="button"
            icon="fa-regular fa-arrow-down"
            class="agpr-videoInput-moveDown"
            (click)="onMoveDown()"
        >
        </button>
    </div>

    <div *ngIf="editable">
        <input
            #textInput
            type="text"
            class="agpr-videoInput-input"
            focus
            pInputText
            [(ngModel)]="content"
            (blur)="onInputBlurred($event)"
            (input)="onValueChanged($event)"
        />
		{{ textInput.focus() }}
    </div>
    <div
        *ngIf="!editable && content && safeEmbedCode"
        class="agpr-videoInput-preview"
        [innerHTML]="safeEmbedCode"
    >
    </div>
    <div
        *ngIf="!editable && content && !safeEmbedCode"
        (click)="onEdit($event)"
        class="agpr-videoInput-invalidValue"
    >
        {{ content }}
        <div
            *ngIf='invalidFormatMessage'
            class='agpr-videoInput-error'
        >
            {{ invalidFormatMessage }}
        </div>
    </div>
    <div
        *ngIf="!editable && !content"
        class="agpr-videoInput-placeholder"
        (click)="onEdit($event)"
    >
        <span class="fa agpr-videoInput-placeholderIcon" [ngClass]="placeholderIcon" aria-hidden="true"></span>
        <span class="agpr-videoInput-placeholderText">{{placeholder}}</span>
    </div>
</div>
